
import { Vue, Component } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import {
  getRules,
  getBaseInfo,
  getUserList,
  deleteActive,
  writeSendCode,
} from '../api';
import { Toast, Icon, List, ImagePreview } from 'vant';
import qs from 'qs';

Vue.use(Icon).use(List);

@Component
export default class Rule extends Vue {
  content = '';
  baseInfo: any = {};
  userList: any[] = [];

  isnodata: boolean = false;
  page = 1;
  loading = false;
  finished = false;

  showNoPass = false;
  noPassList: any = {};

  openWriteCode = false;
  sendcode = '';
  sendCodeId = '';

  opendelitem = false;
  delitemid = '';

  async created() {
    const unionId = window.localStorage.getItem('unionid');
    if (!unionId && isWeiXin()) {
      this.WechatLogin();
    }
    const ret = await getRules();
    if (ret === undefined) {
    } else {
      this.content = ret.data;
    }
    const ret111 = await getBaseInfo();
    this.baseInfo = ret111.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  AppLogin() {
    const token = window.gettoken();
    if (token === 'null' || !token) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return;
    }
  }
  onLoad() {
    const data = {
      udid: window.udid,
      appkey: window.appkey,
      token: window.gettoken(),
      // unionid: 'oGN7AjnndeltK-HSKl5svY5T46Oo',
      unionid: window.localStorage.getItem('unionid'),
      page: this.page,
    };
    getUserList(data).then((res: any) => {
      this.endListData(res);
    });
  }
  showNoPassReasion(item: any) {
    this.noPassList.createtime = this.formatTimestamp(item.createtime);
    this.noPassList.reasion = item.nopass_reasion;
    this.showNoPass = true;
  }
  formatImgList(imgArr: any) {
    let imglsit = imgArr.split('|');
    return imglsit;
  }
  formatTimestamp(timestamp: any) {
    // 创建一个Date对象
    const date = new Date(timestamp * 1000); // 注意：如果时间戳是秒为单位，需要乘以1000转换为毫秒

    // 获取年、月、日、时、分、秒
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的，所以需要+1，并用padStart填充为两位数
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // 拼接成 "yyyy-mm-dd HH:mm:ss" 格式
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  gotoEdit(id: any) {
    this.$router.push('active?detailId=' + id);
  }
  delitem(id: any) {
    this.delitemid = id;
    this.opendelitem = true;
  }
  async deleteActive() {
    const unionId = window.localStorage.getItem('unionid');
    let data = {
      unionid: unionId,
      id: this.delitemid,
    };
    let returndata: any = await deleteActive(data);
    if (returndata.code === 200) {
      Toast.success(returndata.msg);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }
  openSendcode(id: any) {
    this.sendCodeId = id;
    this.openWriteCode = true;
  }
  async writeSendcodeOpen() {
    const unionId = window.localStorage.getItem('unionid');
    let data = {
      unionid: unionId,
      sendCode: this.sendcode,
      id: this.sendCodeId,
    };
    let returndata: any = await writeSendCode(data);
    if (returndata.code === 200) {
      Toast.success(returndata.msg);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.userList = [...this.userList, ...res.data];
    }
    if (this.userList.length === 0) {
      this.isnodata = true;
    }
    this.loading = false;
  }
  onUploadFileClick(fileUrl: string) {
    ImagePreview({
      images: [fileUrl],
      showIndicators: false,
      showIndex: false,
    });
  }
}
